import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    favorites: {
    },
    favoriteCount: 0,
    backgroundImage: ''
  },
  mutations: {
    addFavorite(state, payload) {
      state.favorites[payload.id] = payload.favorite;
      state.favoriteCount++;
    },
    removeFavorite(state, id) {
        delete state.favorites[id];
        state.favoriteCount--;
    },
    setBackgroundImage(state, url) {
      state.backgroundImage = url;
  },
  },
  actions: {
  },
  modules: {
  }
})
